const FitnessCenterHoursIcon = props => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="#14B8A6"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M19.35 18.5H18.3C17.8 18.5 17.4001 18.1 17.4001 17.6L17.4 14H7.59998V17.6C7.59998 18.1 7.2 18.5 6.7 18.5H5.65004C5.15004 18.5 4.75006 18.1 4.75006 17.6V7.40002C4.75006 6.90002 5.15004 6.50004 5.65004 6.50004H6.7C7.2 6.50004 7.59998 6.90002 7.59998 7.40002V11H17.4V7.40002C17.4 6.90002 17.8 6.50004 18.3 6.50004H19.3499C19.8499 6.50004 20.2499 6.90002 20.2499 7.40002L20.25 17.6C20.25 18.1 19.85 18.5 19.35 18.5Z" />
    <path d="M2.57499 16.475H1.52495C1.02495 16.475 0.624969 16.0751 0.624969 15.5751V9.45006C0.624969 8.95006 1.02495 8.55008 1.52495 8.55008H2.57491C3.07491 8.55008 3.47489 8.95006 3.47489 9.45006L3.47497 15.5501C3.47497 16.0501 3.07499 16.4751 2.57499 16.4751L2.57499 16.475Z" />
    <path d="M23.475 16.475H22.425C21.925 16.475 21.5251 16.0751 21.5251 15.5751V9.45006C21.5251 8.95006 21.925 8.55008 22.425 8.55008H23.475C23.975 8.55008 24.375 8.95006 24.375 9.45006V15.5501C24.375 16.0501 23.975 16.4751 23.475 16.4751V16.475Z" />
  </svg>
)

export default FitnessCenterHoursIcon
